import { useState } from 'react';
import { useConversions } from './useConversions';
import { useDeleteConversionEvent } from './useDeleteConversionEvent';
import { useUpdateConversion } from './useUpdateConversion';
import { useValueHighlighter } from './useValueHighlighter';

export const useSetupValue = ({ currentIndex, resetSteps }) => {
    const { conversions } = useConversions();
    const conversion = conversions[currentIndex];
    const [includeValue, setIncludeValue] = useState(true);
    const [isHighlighting, setIsHighlighting] = useState(false);
    const [selectedValue, setSelectedValue] = useState(undefined);

    const handleValueChange = useUpdateConversion({ fieldName: 'valueSelector' });

    const handleDeleteConversion = useDeleteConversionEvent(currentIndex, resetSteps);

    const handleRadioChange = value => {
        const shouldIncludeValue = value === 'select';
        setIncludeValue(shouldIncludeValue);
        if (!shouldIncludeValue) {
            handleValueChange({ value: undefined, currentIndex });
            setSelectedValue(undefined);
        }
    };

    const handleValueSelect = ({ path, value }) => {
        setSelectedValue(value);
        handleValueChange({ value: path, currentIndex });
        setIsHighlighting(false);
    };

    useValueHighlighter({
        isHighlighting,
        onValueClick: handleValueSelect,
    });

    const handleEditValue = () => {
        setIsHighlighting(true);
        setSelectedValue(undefined);
    };

    const canCreateEvent = includeValue ? !!conversion?.valueSelector : true;

    return {
        includeValue,
        isHighlighting,
        selectedValue,
        canCreateEvent,
        handleRadioChange,
        handleDeleteConversion,
        handleEditValue,
        setIsHighlighting,
    };
};
